import * as React from 'react';


import PlacesInput, { TPlace } from './PlacesInput';

interface IProps {
  className?: string;
  onChange(newCities: TPlace[]);

  cities?: TPlace[];
  defaultCities?: TPlace[];
  placeholder?: string;
  debounceWait?: number;
}

const OPTIONS = {
  types: ['(cities)'],
};

const formatter = (prediction: google.maps.places.AutocompletePrediction): TPlace => ({
  label: prediction.description,
  value: prediction.place_id,
});

export const CityInput: React.FunctionComponent<IProps> = (props) => {
  return (
    <PlacesInput
      className={props.className}
      places={props.cities}
      defaultPlaces={props.defaultCities}
      placeholder={props.placeholder}
      onChange={props.onChange}
      emptyOptionsMessage="Start typing city name"
      options={OPTIONS}
      formatPrediction={formatter}
      debounceWait={props.debounceWait}
    />
  );
};

CityInput.defaultProps = {
  placeholder: 'Enter a city',
};
